import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import priorityConfig from '../helpers/priorityConfig';

const PriorityLabel = ({ priority = '' }) => (
  <span className="tickets-index-page__priority-label">
    {priorityConfig[priority].icon}
    {I18n.t(`tickets.priorities.${priority}`)}
  </span>
);

PriorityLabel.propTypes = {
  priority: string,
};

export default PriorityLabel;
